module.exports = __webpack_public_path__ + "2382092a131fb2e10787d3b83d323eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Half Moon.png
// module id = 777
// module chunks = 0